import {
    Box,
    Container,
    SimpleGrid,
    VStack,
    Heading,
    Text,
    Icon
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { BiSolidCalendarEvent } from 'react-icons/bi';
import { BsBuildingsFill } from 'react-icons/bs';
import { MdDiscount } from 'react-icons/md';
import { TbStarsFilled } from "react-icons/tb";

const ServicesSection = () => {
    const { t } = useTranslation();
    
    const featuresData = [
        {
            icon: TbStarsFilled,
            title: "APA Premium",
            description: t("Accès exclusif aux partenaires APA avec des réductions spéciales."),
            gradient: "linear(to-br, purple.400, pink.500)",
            delay: 0.1
        },
        {
            icon: BsBuildingsFill,
            title: "APA Agency",
            description: t("Achetez ou louez des biens immobiliers avec APA, en toute confiance."),
            gradient: "linear(to-br, blue.400, cyan.500)",
            delay: 0.2
        },
        {
            icon: MdDiscount,
            title: "APA Promotions",
            description: t("Consultez nos dernières promotions pour rester informé des offres spéciales et exclusives."),
            gradient: "linear(to-br, orange.400, red.500)",
            delay: 0.3
        },
        {
            icon: BiSolidCalendarEvent,
            title: "APA Events",
            description: t("Restez informé des événements organisés par APA."),
            gradient: "linear(to-br, green.400, green.500)",
            delay: 0.4
        },
    ];

    return (
        <Box as="section" pt="50px" pb="80px" bg="white">
            <Container maxW="container.xl">
                <VStack spacing={12} mb={16}>
                    <Heading 
                        as="h2" 
                        size="2xl" 
                        textAlign="center"
                        bgGradient="linear(to-r, cyan.600, blue.600)"
                        bgClip="text"
                    >
                        {t("Nos Services")}
                    </Heading>
                    <Text 
                        fontSize="lg" 
                        color="gray.600" 
                        textAlign="center" 
                        maxW="2xl"
                    >
                        {t("Découvrez l'ensemble de nos services conçus pour vous offrir la meilleure expérience immobilière")}
                    </Text>
                </VStack>

                <SimpleGrid 
                    columns={{ base: 1, sm: 2, md: 2, lg: 4 }} 
                    spacing={8} 
                    justifyContent="center"
                >
                    {featuresData.map((feature, index) => (
                        <VStack
                            key={index}
                            spacing={4}
                            p={6}
                            bg="white"
                            rounded="2xl"
                            shadow="lg"
                            align="center"
                            textAlign="center"
                            transition="all 0.3s"
                            position="relative"
                            overflow="hidden"
                            _hover={{ 
                                transform: "translateY(-8px)",
                                shadow: "2xl"
                            }}
                            _before={{
                                content: '""',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                bgGradient: feature.gradient,
                                opacity: 0,
                                transition: 'opacity 0.3s',
                                zIndex: 0
                            }}
                            sx={{
                                '&:hover::before': {
                                    opacity: 0.1
                                }
                            }}
                            animation={`fadeIn 0.6s ease-out ${feature.delay}s backwards`}
                        >
                            <Box
                                w={16}
                                h={16}
                                bgGradient={feature.gradient}
                                rounded="xl"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                transition="transform 0.3s"
                                _groupHover={{ transform: "scale(1.1)" }}
                                position="relative"
                                zIndex={1}
                            >
                                <Icon as={feature.icon} boxSize={8} color="white" />
                            </Box>
                            <Heading as="h4" size="md" mt={2} position="relative" zIndex={1}>
                                {feature.title}
                            </Heading>
                            <Text color="gray.600" position="relative" zIndex={1}>
                                {feature.description}
                            </Text>
                        </VStack>
                    ))}
                </SimpleGrid>
            </Container>
        </Box>
    );
};

export default ServicesSection;